export const fonts = {
  body: `'Inter var', 'Helvetica Neue', Arial, sans-serif`,
  heading: `'Inter var', 'Helvetica Neue', Arial, sans-serif`,
  mono: `'SFMono-Regular', Roboto Mono, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace`,
};
